import { render, staticRenderFns } from "./DashboardOverviewCards.vue?vue&type=template&id=2954380c"
import script from "./DashboardOverviewCards.vue?vue&type=script&lang=js"
export * from "./DashboardOverviewCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports